// dependency-graph-ignore-file
import { dbFieldTypeMap, valueToCollabJSON } from '@databases/collab/convert/to-collab';
import { setValueValue } from '@databases/collab/y-database';
import { type Database } from '@databases/model/database';

import { type DatabaseEntry } from '../../types';

interface AddEntryParams {
  entry: DatabaseEntry;
  index?: number;
}

export function addEntry(ydb: Database, { entry, index }: AddEntryParams): void {
  ydb.mutate((db) => {
    const mutableEntry =
      index != null ? db.addEntryAt(entry.id, index) : db.addEntry(entry.id);

    for (const fieldId of Object.keys(entry.values)) {
      const type = dbFieldTypeMap[entry.values[fieldId].type];

      if (!type) {
        throw new Error(
          `Unsupported field type '${entry.values[fieldId].type}' for field '${fieldId}'`
        );
      }

      const value = mutableEntry.setValue(fieldId, type);
      const collabValue = valueToCollabJSON(entry.values[fieldId], {});

      if (collabValue) {
        setValueValue(value, collabValue);
      }
    }
  });
}
